export const categoryMetaList = [
  {
    slug: 'news',
    name: '新闻',
    tagline: '权威及时 · 时事动态',
    description: '汇集财经、科技、社会、健康、教育、体育、文化等领域的新闻资讯，为你呈现权威、及时、多元的时事动态。',
    keywords: '新闻资讯,时事动态,财经新闻,科技新闻,社会新闻',
    subCategories: ['全部', '财经', '科技', '社会', '健康', '教育', '体育', '文化'],
    icon: 'ri-newspaper-line',
  },
  {
    slug: 'life',
    name: '生活',
    tagline: '便捷实用 · 品质服务',
    description: '覆盖家政清洁、数码维修、同城搬家、宠物照护、陪诊陪护、教育辅导、健身指导与旅行定制等生活服务，让日常更便捷。',
    keywords: '生活服务,家政清洁,上门维修,同城搬家,宠物照护,生活便利',
    subCategories: ['全部', '家政', '维修', '搬家', '生活', '医疗', '教育', '健身', '旅行'],
    icon: 'ri-home-smile-2-line',
  },
  {
    slug: 'entertainment',
    name: '娱乐',
    tagline: '热点速递 · 精彩不断',
    description: '聚焦影视、音乐、游戏与综艺等娱乐内容，追踪热门剧集、现场演出与电竞赛事，带你掌握潮流热点。',
    keywords: '娱乐内容,影视,音乐,游戏,综艺,热门剧集,电竞',
    subCategories: ['全部', '影视', '音乐', '游戏', '综艺'],
    icon: 'ri-movie-2-line',
  },
];

export const hotSearches = [
  '消费补贴',
  '人工智能',
  '新能源汽车',
  '音乐节',
  '流感防护',
  '数字人民币',
  '国风动画',
  '电竞总决赛',
];

export const topicSpots = [
  {
    id: 'topic-1',
    title: '信心与活力：观察消费市场新动向',
    desc: '从补贴新政到消费场景创新，专题梳理近期消费市场的热点与趋势。',
    image:
      'https://readdy.ai/api/search-image?query=Vibrant%20modern%20shopping%20mall%20interior%20with%20bright%20light%20and%20elegant%20architecture%2C%20editorial%20feature%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=topic-01&orientation=landscape',
    link: '/category/news',
    label: '热点报道',
  },
  {
    id: 'topic-2',
    title: '一站式生活服务：让日常更省心',
    desc: '精选家政、维修、搬家等高频生活服务，帮你在忙碌中轻松打理生活。',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20tidy%20home%20interior%20with%20organized%20shelves%20and%20green%20plants%2C%20editorial%20lifestyle%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=600&seq=topic-02&orientation=landscape',
    link: '/category/life',
    label: '服务合集',
  },
  {
    id: 'topic-3',
    title: '年度娱乐盘点：这些内容别错过',
    desc: '热播剧集、现场音乐与电竞赛事逐一亮相，盘点值得一看的娱乐内容。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20warm%20stage%20lights%20with%20blurred%20crowd%20silhouettes%2C%20editorial%20entertainment%20photography%2C%20clean%20dark%20neutral%20background%2C%20dramatic%20lighting%2C%20high%20detail&width=800&height=600&seq=topic-03&orientation=landscape',
    link: '/category/entertainment',
    label: '娱乐盘点',
  },
];

export const siteIntro = {
  title: '关于 91网站',
  desc: '91网站是一家覆盖新闻资讯、生活服务、娱乐内容等多个领域的综合门户平台，致力于为网民提供权威、及时、实用的信息与便捷的在线服务，提升日常生活质量与信息获取效率。',
  stats: [
    { label: '每日更新资讯', value: '500+' },
    { label: '覆盖服务品类', value: '30+' },
    { label: '注册用户', value: '120万+' },
    { label: '合作机构', value: '200+' },
  ],
};